import React from 'react';
import { useCssHandles } from '../../utils/functions';

const CSS_HANDLES = [
	'submenuItem',
	'styledLinkContainer',
	'styledLink',
	'styledLinkContent',
	'styledLinkText',
	'seeAllLinkContainer',
	'seeAllLink',
];
const ThirdLevelDesktop = ({ blockClass, items }) => {
	const { handles } = useCssHandles(`vtex-mega-menu-2-x`, CSS_HANDLES, blockClass);

	return (
		<>
			{items?.map(({ name }) => (
				<div className={`${handles.submenuItem} mt3`}>
					<div className={`${handles.styledLinkContainer}`}>
						<a className={`${handles.styledLink} no-underline c-on-base w-100 pa0 t-body pointer`} href="#">
							<div className={`${handles.styledLinkContent} flex justify-between`}>
								<div className={`${handles.styledLinkText} flex justify-between items-center`}>{name}</div>
							</div>
						</a>
					</div>
				</div>
			))}
			<div className={`${handles.seeAllLinkContainer} mt4 mb6 t-body`}>
				<a href="#" className={`${handles.seeAllLink} link underline fw7 c-on-base`}>
					Ver tudo
				</a>
			</div>
		</>
	);
};

export default ThirdLevelDesktop;
